export default __webpack_public_path__ + "static/media/01.dc4fa434.jfif";